import React, { useState, useEffect } from "react";
import IconHeader from "../components/Typography";
import { SignInDialog } from "../components/Dialogs/SignInDialog";
import { NavigationList } from "../components/Lists";
import { StartMenuItems } from "../components/Layout/nav-models";
import { Col } from "../components/Layout/Space";
import { pingForLogin } from "../../auth/broadcast";
import { usePython } from "../hooks/usePython";
import Env from "xlcommon/src/environ";
import * as AuthAPI from "../../auth/auth-api";
import { resetTermsAndConditions } from "./AIAssistant/utils";
import "./Start.scss";

function Start() {
  const { hasPython } = usePython();

  // User must login when the add-in first opens
  const [isLoggedIn, setLoggedIn] = useState<boolean>(true); // initial condition to avoid showing login dialog when cross-linked
  const [isAutoLogIn, setIsAutoLogIn] = useState<boolean>(false);
  async function triggerSignIn() {
    if (!Env.signedIn) await AuthAPI.login();
    setLoggedIn(Env.signedIn);
    resetTermsAndConditions();
  }

  useEffect(() => {
    (async () => {
      // Attempt linked-login from PyScript page
      if (!AuthAPI.isLoggedIn()) pingForLogin(triggerSignIn);

      // Check for login status (after delay)
      setTimeout(async () => {
        if (!AuthAPI.isLoggedIn()) {
          // Linked login failed, so show login dialog
          setLoggedIn(false);
          // Attempt auto-login using microsoft token
          setIsAutoLogIn(true);
          await AuthAPI.attemptSilentLogin();
          if (AuthAPI.isLoggedIn()) setLoggedIn(true);
          setIsAutoLogIn(false);
        }
      }, 250);
    })();
  }, []);

  return (
    <div style={{ paddingTop: 8 }}>
      {!isLoggedIn && (
        <SignInDialog
          title="Sign In Required"
          content="To use Anaconda Toolbox, please sign in to your Anaconda account."
          defaultOpen={true}
          onContinue={async () => await triggerSignIn()}
          initializing={isAutoLogIn}
        />
      )}
      <div className="start-menu">
        <Col>
          {StartMenuItems.map((heading) => {
            return (
              <div key={heading.title}>
                <IconHeader Icon={<heading.Icon />} text={heading.title} />
                <NavigationList
                  items={heading.items.map((item) => {
                    const disabled = item.disabled || (item.requiresPython && !hasPython && !Env.UNLOCKED);
                    return {
                      text: item.text,
                      to: item.path,
                      disabled: disabled,
                      disabledText: disabled ? "Requires Python in Excel" : "",
                    };
                  })}
                />
              </div>
            );
          })}
        </Col>
      </div>
      {Office.context.platform === Office.PlatformType.Mac && (
        <footer style={{ marginLeft: "8px" }}>
          {" "}
          Looking for Anaconda Code? Click{" "}
          <a href="" onClick={() => (window.location.href = "/pyscript/?version=1.1.0")}>
            here
          </a>
          .
        </footer>
      )}
    </div>
  );
}

export default Start;
